import { render } from "./PassS12List.vue?vue&type=template&id=3085e910"
import script from "./PassS12List.vue?vue&type=script&lang=js"
export * from "./PassS12List.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__